export default __webpack_public_path__ + "static/media/Negocie.f7b3b50c.png";